export class Particle {
    public x: number;
    public y: number;
    public vx: number;
    public vy: number;
    public color: string;
    public life: number;
    public lifeDecay: number;
    public size: number;
    public isAlive: boolean;

    constructor(x: number, y: number, vx: number, vy: number, color: string) {
        this.x = x;
        this.y = y;
        this.vx = vx;
        this.vy = vy;
        this.color = color;
        this.life = 1.0; // 1.0 = alive, 0.0 = dead
        this.lifeDecay = 2.0; // life per second
        this.size = 2;
        this.isAlive = true;
    }

    /**
     * 풀링을 위한 리셋 메서드
     */
    reset(x: number, y: number, vx: number, vy: number, color: string): void {
        this.x = x;
        this.y = y;
        this.vx = vx;
        this.vy = vy;
        this.color = color;
        this.life = 1.0;
        this.lifeDecay = 2.0;
        this.size = 2;
        this.isAlive = true;
    }

    update(deltaTime: number): void {
        // Update position
        this.x += this.vx * deltaTime;
        this.y += this.vy * deltaTime;

        // Apply gravity
        this.vy += 200 * deltaTime;

        // Decay life
        this.life -= this.lifeDecay * deltaTime;

        if (this.life <= 0) {
            this.isAlive = false;
        }
    }

    render(ctx: CanvasRenderingContext2D): void {
        ctx.globalAlpha = this.life;
        ctx.fillStyle = this.color;
        ctx.fillRect(this.x - this.size / 2, this.y - this.size / 2, this.size, this.size);
        ctx.globalAlpha = 1.0;
    }
}
